var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H5a2.143 2.143 0 00-2.143 2.143v15.714A2.143 2.143 0 005 20h10a2.143 2.143 0 002.143-2.143V2.143A2.143 2.143 0 0015 0zm-5 2.143a2.143 2.143 0 11-2.143 2.143A2.143 2.143 0 0110 2.143zm0 15.714a4.286 4.286 0 114.286-4.286A4.286 4.286 0 0110 17.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.857 13.571a2.143 2.143 0 104.286 0 2.143 2.143 0 10-4.286 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/stage.698c62e7.svg";
export { ForwardRef as ReactComponent };